/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoTwitterIcon16Light = forwardRef('LogoTwitterIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.878 2.827a.5.5 0 1 0-.756-.654l-3.498 4.05-3.042-4.025a.5.5 0 0 0-.4-.198H2.5a.5.5 0 0 0-.399.802l4.424 5.851-3.903 4.52a.5.5 0 1 0 .756.654l3.764-4.358 3.276 4.333a.5.5 0 0 0 .4.198H13.5a.5.5 0 0 0 .399-.802L9.24 7.038l3.637-4.211ZM11.066 13 3.505 3h1.43l7.56 10h-1.43Z" })));
});
